export enum QuoteExpirationTimeFilters {
  ONE_WEEK = 'one_week',
  ONE_TWO_WEEK = 'one_two_week',
  TWO_FOUR_WEEK = 'two_four_week',
  FOUR_EIGHT_WEEK = 'four_eight_week',
  EIGHT_WEEK = 'eight_week',
}
